<template>
  <section class="behno-press-section" :style="marginTopBottom">
    <h1 aria-label="Behno in global press" class="press-page-title card_heading_b sr-only">
      behno in global press
    </h1>
    <div class="press-image-grid">
      <component
        :is="item.imageLink ? 'a' : 'div'"
        v-for="(item, index) in shopifyData.image_data"
        :key="index"
        :href="item.imageLink || null"
        class="press-image-item"
        :class="{ url_link_image: item.imageLink }"
      >
        <img
          v-lazy="item.previewImg.src"
          :alt="item.previewImg.alt || 'Press Image'"
          class="image press-image"
          loading="lazy"
          aria-hidden="true"
          aria-label="Press Image"
          width=""
          height=""
        />
      </component>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    marginTopBottom() {
      return {
        paddingTop:
          this.screenWidth > 768
            ? `${this.shopifyData.deskMarginTop}px`
            : `${this.shopifyData.mobMarginTop}px`,
        paddingBottom:
          this.screenWidth > 768
            ? `${this.shopifyData.deskMarginBottom}px`
            : `${this.shopifyData.mobMarginBottom}px`,
      };
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWidth);
  },
  methods: {
    updateWidth() {
      this.screenWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped>
.press-image-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
}

.image {
  display: block;
  height: 100%;
  width: 100%;
}

.url_link_image {
  cursor: pointer;
}

.press-image-item {
  border: 1px solid #d7d7d7;
  border-left: none;
  border-top: none;
}

@media only screen and (min-width: 1200px) {
  /* Remove top border for the first row (first 4 items) */
  .press-image-item:nth-child(-n + 4) {
    border-top: 1px solid #d7d7d7;
  }

  /* Remove left border for leftmost items (1st, 5th, 9th, etc.) */
  .press-image-item:nth-child(4n + 1) {
    border-left: 1px solid #d7d7d7;
  }

  /* Remove bottom border for the last row (last 4 items) */
  .press-image-item:nth-last-child(-n + 4) {
    border-bottom: 1px solid #d7d7d7;
  }
}

@media only screen and (max-width: 1200px) and (min-width: 769px) {
  .press-image-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  /* No top border for first row (items 1-3) */
  .press-image-item:nth-child(-n + 3) {
    border-top: 1px solid #d7d7d7;
  }

  /* left border for leftmost items (1st, 4th, 7th, etc.) */
  .press-image-item:nth-child(3n + 1) {
    border-left: 1px solid #d7d7d7;
  }

  /* right border for rightmost items (3rd, 6th, 9th, etc.) */
  .press-image-item:nth-child(3n) {
    border-right: 1px solid #d7d7d7;
  }

  /* bottom border for last row (last 3 items) */
  .press-image-item:nth-last-child(-n + 3) {
    border-bottom: 1px solid #d7d7d7;
  }
}

@media only screen and (max-width: 768px) {
  .press-image-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  /* No top border for first row (items 1-2) */
  .press-image-item:nth-child(-n + 2) {
    border-top: 1px solid #d7d7d7;
  }

  /* No left border for leftmost items (1st, 3rd, 5th, etc.) */
  .press-image-item:nth-child(2n + 1) {
    border-left: 1px solid #d7d7d7;
    border-right: 1px solid #d7d7d7;
  }

  /* No right border for rightmost items (2nd, 4th, 6th, etc.) */
  .press-image-item:nth-child(2n) {
    border-right: 1px solid #d7d7d7;
  }

  /* No bottom border for last row (last 2 items) */
  .press-image-item:nth-last-child(-n + 2) {
    border-bottom: 1px solid #d7d7d7;
    border-top: 1px solid #d7d7d7;
  }
}
</style>
